import {
  MailOutlined,
  PhoneOutlined,
  ThunderboltOutlined,
  TeamOutlined,
  TrophyOutlined,
  UserOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import baseUrl from "../../utils/baseUrl";
import { Image, Tag } from "antd";
import { Col, Row, Alert } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import {
  clearUser,
  deleteStaff,
  loadSingleStaff,
} from "../../redux/rtk/features/user/userSlice";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import BtnDeleteSvg from "../UI/Button/btnDeleteSvg";

import EmployeeDesignation from "../UI/EmployeeDesignation";
import EmployeeTimeline from "../UI/EmployeeTimeline";
import DesignationEditPopup from "../UI/PopUp/DesignationEditPopup";
import EducaitonEditPopup from "../UI/PopUp/EducaitonEditPopup";
import ProfileEditPopup from "../UI/PopUp/ProfileEditPopup";

import SalaryEditPopup from "../UI/PopUp/SalaryEditPopup";
import EmployeeSalary from "../UI/EmployeeSalary";

import EmployeeAward from "../UI/EmployeeAward";

import AwardHistoryEditPopup from "../UI/PopUp/AwardHistoryEditPopup";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";

const DetailStaff = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.users.user);
  const error = useSelector((state) => state.users.error);
  const designation = useSelector((state) => state.designations.list);

  const onDelete = () => {
    try {
      dispatch(deleteStaff(id));
      setVisible(false);
      // toast.warning(`User Name : ${user?.username} is removed `);
      return navigate("/admin/hr/staffs");
    } catch (error) {
      console.log(error.message);
    }
  };

  const [visible, setVisible] = useState(false);
  const handleVisibleChange = (newVisible) => setVisible(newVisible);

  useEffect(() => {
    dispatch(loadSingleStaff(id));
    return () => dispatch(clearUser());
  }, [id]);

  useEffect(() => {
    dispatch(loadAllDesignation());
  }, [dispatch]);

  const isLogged = Boolean(localStorage.getItem("isLogged"));
  if (!isLogged) return <Navigate to={"/admin/auth/login"} replace={true} />;

  return (
    <div>
      <UserPrivateComponent permission={"readSingle-user"}>
        <PageTitle title=" Back  " />

        {user ? (
          <div className="mr-top">
            <section>
              <div className="flex justify-between ant-card rounded h-auto mr-8">
                <div className="flex justify-start">
                  <div className="flex justify-center py-8 px-4 mt-4 ml-4">
                    <div className="flex flex-col items-around">
                      {user?.image ? (
                        <Image
                          width={100}
                          src={`${baseUrl}/files/${user.image}`}
                          alt="User"
                          style={{ borderRadius: "50%", marginTop:"-28%" }}
                        />
                      ) : (
                        <h3 className="text-base font-medium txt-color-secondary">
                          No Image
                        </h3>
                      )}

                      <h1 className="text-2xl font-bold txt-color-2 mb-1">
                        {(user?.firstName + " " + user?.lastName).toUpperCase()}
                      </h1>
                      <h2 className="text-base font-medium txt-color-secondary mb-1">
                        {user?.email || "No email"}
                      </h2>
                      <h2 className="text-base font-medium txt-color-secondary mb-1">
                        {user?.phone || "No phone"}
                      </h2>

                     <h3 className="text-base font-medium txt-color-secondary">
    {user?.role?.name || "No Employee ID"}
  </h3>
  {user?.roleId === 3 && (
    <h3 className="text-base font-medium txt-color-secondary">
      Hourly Rate: €<span className="txt-color-2">{user?.hourlyRate ?? "N/A"}</span>
    </h3>
  )}
    {user?.roleId === 3 && (
    <h3 className="text-base font-medium txt-color-secondary">
      Total Earnings: €<span className="txt-color-2">{user?.totalEarnings ?? "N/A"}</span>
    </h3>
  )}
 {user?.roleId === 3 && (
  <div className="flex items-center gap-2">
    <h3 className="text-base font-medium txt-color-secondary">
      Rating:
    </h3>
    <div className="flex">
      {[...Array(5)].map((_, index) => (
        <span key={index}>
          {index < Math.round(user?.rating || 0) ? "⭐" : "☆"}
        </span>
      ))}
    </div>
    <span className="txt-color-2 ml-2">({user?.rating ?? "N/A"})</span>
  </div>
)}

                      {/* Employment Status Tags */}
                      <div className="mt-2">
                        {user?.roleId === 1 ? (
                          <Tag color="red">Admin</Tag>
                        ) : user?.employmentStatuses?.length > 0 ? (
                          user.employmentStatuses.map((status) => (
                            <Tag key={status.id} color="green">
                              {status.name}
                            </Tag>
                          ))
                        ) : (
                          <Tag color="pink">Customer</Tag>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className='flex justify-center py-8 px-4 mt-4'>
									<div className='flex flex-col items-around'>
										<h1 className='text-2xl font-bold txt-color-2 mb-1'>Leave Status</h1>
										<h3 className='text-base font-medium txt-color-secondary'>
											Leaves : Paid - {user?.leavePolicy?.paidLeaveCount} | U.Paid - {user?.leavePolicy?.unpaidLeaveCount}
										</h3>
										<h3 className='text-base font-medium txt-color-secondary'>
											Taken : Paid - {user?.leavePolicy?.paidLeaveCount - user?.leftPaidLeaveDays} | U.Paid - {user?.leavePolicy?.unpaidLeaveCount - user?.leftUnpaidLeaveDays}
										</h3>
										<h3 className='text-base font-medium txt-color-secondary'>
											Balance : Paid - {user?.leftPaidLeaveDays} | U.Paid - {user?.leftUnpaidLeaveDays}
										</h3>
									</div>
								</div> */}

                <div className='flex justify-center py-8 px-4 mt-20'>
									<div className='flex flex-col items-around'>
										<h1 className='text-2xl font-bold txt-color-2 mb-1'>Address Information</h1>
										<h3 className='text-base font-medium txt-color-secondary'>
  Address : <span className='text-base font-medium txt-color-2'>
    {user?.street || "N/A"}
  </span>
</h3>
									<h3 className='text-base font-medium txt-color-secondary'>
  City : <span className='text-base font-medium txt-color-2'>
    {user?.city || "N/A"}
  </span>
</h3>
                    									<h3 className='text-base font-medium txt-color-secondary'>
  Country : <span className='text-base font-medium txt-color-2'>
    {user?.country || "N/A"}
  </span>
</h3>
									</div>
								</div>

                <div className="flex justify-center py-8 px-4 mt-10 mr-4">
                  <UserPrivateComponent permission="update-user">
                    <button className="mr-2 mt-2">
                      {user && <ProfileEditPopup data={user} />}
                    </button>
                  </UserPrivateComponent>
                  <UserPrivateComponent permission="delete-user">
                    <button onClick={onDelete}>
                      <BtnDeleteSvg size={30} />
                    </button>
                  </UserPrivateComponent>
                </div>
              </div>
            </section>
            {/* Additional sections unchanged; use optional chaining in all nested user accesses */}
          </div>
        ) : (
          <div className="mt-10">
            <Loader />
            {error && <p className="text-center mt-3 mb-3">No Data Found</p>}
          </div>
        )}
      </UserPrivateComponent>
    </div>
  );
};

const ProfileCardText = tw.div`
txt-color-2
text-xl
text-center
mt-5
`;

const Hr = tw.hr`
mt-3
mb-3
new-hr
`;

export default DetailStaff;
